import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Sidebar } from './sidebar';
import { CommandPalette } from '@/components/command-palette';
import { ChatBubble } from '@/components/chat-bubble';
import { useUIStore } from '@/stores';
import { cn } from '@/lib/utils';

interface MainLayoutProps {
  children?: React.ReactNode;
}

/**
 * Main application layout.
 * Wraps pages with header and sidebar.
 * Includes global command palette (Cmd+K).
 */
export function MainLayout({ children }: MainLayoutProps) {
  const { isSidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header clientName="ABC Corporation" />
      <Sidebar />
      <main
        className={cn(
          'min-h-[calc(100vh-4rem)] transition-all duration-300',
          isSidebarCollapsed ? 'ml-16' : 'ml-60'
        )}
      >
        <div className="p-6">
          {children ?? <Outlet />}
        </div>
      </main>
      <CommandPalette />
      <ChatBubble />
    </div>
  );
}
